export const generateEventSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "Event",
    "name": "Riviera Rounds for Charity",
    "description": "Exclusive charity golf event at Riviera Country Club supporting The Center for Childhood",
    "startDate": "2026-04-10T08:00:00-07:00",
    "endDate": "2026-04-23T18:00:00-07:00",
    "eventStatus": "https://schema.org/EventScheduled",
    "eventAttendanceMode": "https://schema.org/OfflineEventAttendanceMode",
    "location": {
      "@type": "Place",
      "name": "Riviera Country Club",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "1250 Capri Dr",
        "addressLocality": "Pacific Palisades",
        "addressRegion": "CA",
        "postalCode": "90272",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "34.0522",
        "longitude": "-118.5311"
      }
    },
    "organizer": {
      "@type": "Organization",
      "name": "Bucket List Series",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/3583e5e2b78d0b331199ba2568c9c533.png"
    },
    "offers": {
      "@type": "Offer",
      "price": "2450",
      "priceCurrency": "USD",
      "availability": "https://schema.org/LimitedAvailability",
      "url": siteUrl,
      "validFrom": "2025-01-15T00:00:00-08:00"
    },
    "image": "https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/a62459178d61176fc44eab1dbac59ab3.jpeg",
    "url": siteUrl,
    "performer": {
      "@type": "Organization",
      "name": "Bucket List Golf"
    }
  };
};

export const generateFAQSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How does registration work?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Once registration is open, members are selected on a first-come, first-served basis. Members may select their preferred date from the available April options (April 10th, 15th, 16th, 21st, 22nd, or 23rd). Payment is taken at time of registration, but refunds are issued automatically if the event sells out. Selected members are notified by email when they have been accepted to play. Once the event sells out, additional members are placed on a waitlist. Waitlisted members are chosen by lottery if spots become available due to cancellations."
        }
      },
      {
        "@type": "Question",
        "name": "What is the cancellation policy?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Cancellations are allowed up to one week before the event. Since this is a last minute signup, cancellation may not be possible. Refunds are processed once the spot is filled, minus a 5% processing fee. Please email refund requests to chris.leary@bucketlistgolf.org."
        }
      },
      {
        "@type": "Question",
        "name": "Who can sign up for the events?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Events are first open to Bucket List Series members on Thousand Greens. If spots remain, registration opens to the public (including Broken Tee Society and other golf groups). Members are welcomed to sign up multiple players, but members must be registered on the Bucket List Series website on Golf Genius. Every effort will be made to pair groups together when registering multiple players."
        }
      },
      {
        "@type": "Question",
        "name": "What's included in the event fees?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Each event is custom-curated for the venue and the event. Event fees usually include greens fees, cart/caddie, meals, tee gifts, pro shop credit, breakfast, lunch, or dinner receptions, etc. Some events may include travel and lodging. Full details are listed in the 'What's Included' section on the Bucket List Series Golf Genius website."
        }
      },
      {
        "@type": "Question",
        "name": "What happens if the event is canceled due to weather?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Weather cancellations are determined at the sole discretion of the golf course. Refunds will be provided whenever applicable. If the event proceeds in extremely bad weather, impacted members will receive first right of refusal for the next year's event at that location."
        }
      },
      {
        "@type": "Question",
        "name": "Are singles welcomed?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Absolutely! Come as a group, or come as a single and meet other new friends from BLS."
        }
      },
      {
        "@type": "Question",
        "name": "Are there handicap or skill requirements?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Players of all skill levels and handicaps are welcome to register. Pace of play is very important, so we just ask you to keep up with the group in front of you. Double-bogey max scoring will be in place to ensure pace of play. A GHIN or other accredited handicap is required to compete in the NET division."
        }
      },
      {
        "@type": "Question",
        "name": "What is the dress code?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Proper golf attire is required. Collared shirts, golf pants or shorts, and golf shoes are mandatory. No denim or athletic wear."
        }
      },
      {
        "@type": "Question",
        "name": "What is not included in the registration fees?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Airfare and lodging are not included in these fees. All costs for golf, meals, caddie, and open bar (within course policy) are covered with registration."
        }
      }
    ]
  };
};

export const generateOrganizationSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Bucket List Series",
    "alternateName": "Bucket List Golf",
    "url": siteUrl,
    "logo": "https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/3583e5e2b78d0b331199ba2568c9c533.png",
    "description": "Exclusive golf events at legendary courses. Where the game takes us.",
    "email": "Info@BucketListGolf.org",
    "telephone": "+1-413-222-7701",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pacific Palisades",
      "addressRegion": "CA",
      "addressCountry": "US"
    },
    "sameAs": [
      "https://bucketlistgolf.org"
    ]
  };
};

export const generateWebPageSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  return {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Bucket List Series - Riviera Rounds for Charity",
    "description": "Join the exclusive Riviera Rounds for Charity golf event at legendary Riviera Country Club. Play where PGA Tour legends compete while supporting The Center for Childhood.",
    "url": siteUrl,
    "inLanguage": "en-US",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Bucket List Series",
      "url": siteUrl
    },
    "about": {
      "@type": "Event",
      "name": "Riviera Rounds for Charity"
    },
    "primaryImageOfPage": {
      "@type": "ImageObject",
      "url": "https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/a62459178d61176fc44eab1dbac59ab3.jpeg",
      "width": 1200,
      "height": 630
    }
  };
};
